// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m_17884d0f {
  --carousel-height: auto;
  position: relative;
}

.m_a2dae653 {
  height: var(--carousel-height);
  overflow: hidden;
}

.m_a2dae653[data-type='container'] {
    container: carousel / inline-size;
  }

.m_fcd81474 {
  display: flex;
  flex-direction: row;
  height: var(--carousel-height);
}

:where([data-include-gap-in-size]) .m_fcd81474:where([data-orientation='vertical']) {
      margin-bottom: calc(var(--carousel-slide-gap) * -1);
    }

:where([data-include-gap-in-size]) .m_fcd81474:where([data-orientation='horizontal']) {
      margin-inline-end: calc(var(--carousel-slide-gap) * -1);
    }

.m_fcd81474:where([data-orientation='vertical']) {
    flex-direction: column;
  }

.m_39bc3463 {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
  pointer-events: none;
}

.m_39bc3463:where([data-orientation='vertical']) {
    inset-inline-start: calc(50% - var(--carousel-control-size) / 2);
    top: 0;
    bottom: 0;
    flex-direction: column;
    padding: var(--carousel-controls-offset) 0;
  }

.m_39bc3463:where([data-orientation='horizontal']) {
    inset-inline-start: 0;
    inset-inline-end: 0;
    top: calc(50% - var(--carousel-control-size) / 2);
    flex-direction: row;
    padding: 0 var(--carousel-controls-offset);
  }

.m_64f58e10 {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: var(--carousel-control-size);
  min-height: var(--carousel-control-size);
  border-radius: var(--carousel-control-size);
  pointer-events: all;
  background-color: var(--mantine-color-white);
  color: var(--mantine-color-black);
  box-shadow: var(--mantine-shadow-md);
  border: 1px solid var(--mantine-color-gray-3);
  transition: opacity 100ms ease;
}

:where([data-mantine-color-scheme='light']) .m_64f58e10 {
    opacity: 0.85;
}

:where([data-mantine-color-scheme='dark']) .m_64f58e10 {
    opacity: 0.65;
}

@media (hover: hover) {

  .m_64f58e10:hover {
    opacity: 1;
  }
}

@media (hover: none) {

  .m_64f58e10:active {
    opacity: 1;
  }
}

.m_71ea3ab1 {
  position: absolute;
  display: flex;
  justify-content: center;
  gap: calc(0.5rem * var(--mantine-scale));
  pointer-events: none;
}

.m_71ea3ab1:where([data-orientation='vertical']) {
    bottom: 0;
    top: 0;
    inset-inline-end: var(--mantine-spacing-md);
    flex-direction: column;
  }

.m_71ea3ab1:where([data-orientation='horizontal']) {
    bottom: var(--mantine-spacing-md);
    inset-inline-start: 0;
    inset-inline-end: 0;
    flex-direction: row;
  }

.m_eae68602 {
  pointer-events: all;
  border-radius: var(--mantine-radius-xl);
  box-shadow: var(--mantine-shadow-sm);
  opacity: 0.6;
  background-color: var(--mantine-color-white);
}

@media (hover: hover) {

  .m_eae68602:hover {
    opacity: 1;
  }
}

@media (hover: none) {

  .m_eae68602:active {
    opacity: 1;
  }
}

.m_eae68602:where([data-active]) {
    opacity: 1;
  }

.m_eae68602:where([data-orientation='vertical']) {
    width: calc(0.3125rem * var(--mantine-scale));
    height: calc(1.5625rem * var(--mantine-scale));
  }

.m_eae68602:where([data-orientation='horizontal']) {
    width: calc(1.5625rem * var(--mantine-scale));
    height: calc(0.3125rem * var(--mantine-scale));
  }

.m_d98df724 {
  position: relative;
  flex: 0 0 var(--carousel-slide-size, 100%);
}

.m_17884d0f:where([data-include-gap-in-size]) .m_d98df724:where([data-orientation='vertical']) {
      padding-bottom: var(--carousel-slide-gap);
    }

.m_17884d0f:where([data-include-gap-in-size]) .m_d98df724:where([data-orientation='horizontal']) {
      padding-inline-end: var(--carousel-slide-gap);
    }

.m_17884d0f:where(:not([data-include-gap-in-size])) .m_d98df724:where([data-orientation='vertical']) {
      margin-bottom: var(--carousel-slide-gap);
    }

.m_17884d0f:where(:not([data-include-gap-in-size])) .m_d98df724:where([data-orientation='horizontal']) {
      margin-inline-end: var(--carousel-slide-gap);
    }
`, "",{"version":3,"sources":["webpack://./node_modules/@mantine/carousel/styles.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;IACI,iCAAiC;EACnC;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;MACM,mDAAmD;IACrD;;AAEJ;MACM,uDAAuD;IACzD;;AAEJ;IACI,sBAAsB;EACxB;;AAEF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,UAAU;EACV,oBAAoB;AACtB;;AAEA;IACI,gEAAgE;IAChE,MAAM;IACN,SAAS;IACT,sBAAsB;IACtB,0CAA0C;EAC5C;;AAEF;IACI,qBAAqB;IACrB,mBAAmB;IACnB,iDAAiD;IACjD,mBAAmB;IACnB,0CAA0C;EAC5C;;AAEF;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uCAAuC;EACvC,wCAAwC;EACxC,2CAA2C;EAC3C,mBAAmB;EACnB,4CAA4C;EAC5C,iCAAiC;EACjC,oCAAoC;EACpC,6CAA6C;EAC7C,8BAA8B;AAChC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;;EAEE;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;IACI,SAAS;IACT,MAAM;IACN,2CAA2C;IAC3C,sBAAsB;EACxB;;AAEF;IACI,iCAAiC;IACjC,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;EACrB;;AAEF;EACE,mBAAmB;EACnB,uCAAuC;EACvC,oCAAoC;EACpC,YAAY;EACZ,4CAA4C;AAC9C;;AAEA;;EAEE;IACE,UAAU;EACZ;AACF;;AAEA;;EAEE;IACE,UAAU;EACZ;AACF;;AAEA;IACI,UAAU;EACZ;;AAEF;IACI,6CAA6C;IAC7C,8CAA8C;EAChD;;AAEF;IACI,6CAA6C;IAC7C,8CAA8C;EAChD;;AAEF;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;MACM,yCAAyC;IAC3C;;AAEJ;MACM,6CAA6C;IAC/C;;AAEJ;MACM,wCAAwC;IAC1C;;AAEJ;MACM,4CAA4C;IAC9C","sourcesContent":[".m_17884d0f {\n  --carousel-height: auto;\n  position: relative;\n}\n\n.m_a2dae653 {\n  height: var(--carousel-height);\n  overflow: hidden;\n}\n\n.m_a2dae653[data-type='container'] {\n    container: carousel / inline-size;\n  }\n\n.m_fcd81474 {\n  display: flex;\n  flex-direction: row;\n  height: var(--carousel-height);\n}\n\n:where([data-include-gap-in-size]) .m_fcd81474:where([data-orientation='vertical']) {\n      margin-bottom: calc(var(--carousel-slide-gap) * -1);\n    }\n\n:where([data-include-gap-in-size]) .m_fcd81474:where([data-orientation='horizontal']) {\n      margin-inline-end: calc(var(--carousel-slide-gap) * -1);\n    }\n\n.m_fcd81474:where([data-orientation='vertical']) {\n    flex-direction: column;\n  }\n\n.m_39bc3463 {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.m_39bc3463:where([data-orientation='vertical']) {\n    inset-inline-start: calc(50% - var(--carousel-control-size) / 2);\n    top: 0;\n    bottom: 0;\n    flex-direction: column;\n    padding: var(--carousel-controls-offset) 0;\n  }\n\n.m_39bc3463:where([data-orientation='horizontal']) {\n    inset-inline-start: 0;\n    inset-inline-end: 0;\n    top: calc(50% - var(--carousel-control-size) / 2);\n    flex-direction: row;\n    padding: 0 var(--carousel-controls-offset);\n  }\n\n.m_64f58e10 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: var(--carousel-control-size);\n  min-height: var(--carousel-control-size);\n  border-radius: var(--carousel-control-size);\n  pointer-events: all;\n  background-color: var(--mantine-color-white);\n  color: var(--mantine-color-black);\n  box-shadow: var(--mantine-shadow-md);\n  border: 1px solid var(--mantine-color-gray-3);\n  transition: opacity 100ms ease;\n}\n\n:where([data-mantine-color-scheme='light']) .m_64f58e10 {\n    opacity: 0.85;\n}\n\n:where([data-mantine-color-scheme='dark']) .m_64f58e10 {\n    opacity: 0.65;\n}\n\n@media (hover: hover) {\n\n  .m_64f58e10:hover {\n    opacity: 1;\n  }\n}\n\n@media (hover: none) {\n\n  .m_64f58e10:active {\n    opacity: 1;\n  }\n}\n\n.m_71ea3ab1 {\n  position: absolute;\n  display: flex;\n  justify-content: center;\n  gap: calc(0.5rem * var(--mantine-scale));\n  pointer-events: none;\n}\n\n.m_71ea3ab1:where([data-orientation='vertical']) {\n    bottom: 0;\n    top: 0;\n    inset-inline-end: var(--mantine-spacing-md);\n    flex-direction: column;\n  }\n\n.m_71ea3ab1:where([data-orientation='horizontal']) {\n    bottom: var(--mantine-spacing-md);\n    inset-inline-start: 0;\n    inset-inline-end: 0;\n    flex-direction: row;\n  }\n\n.m_eae68602 {\n  pointer-events: all;\n  border-radius: var(--mantine-radius-xl);\n  box-shadow: var(--mantine-shadow-sm);\n  opacity: 0.6;\n  background-color: var(--mantine-color-white);\n}\n\n@media (hover: hover) {\n\n  .m_eae68602:hover {\n    opacity: 1;\n  }\n}\n\n@media (hover: none) {\n\n  .m_eae68602:active {\n    opacity: 1;\n  }\n}\n\n.m_eae68602:where([data-active]) {\n    opacity: 1;\n  }\n\n.m_eae68602:where([data-orientation='vertical']) {\n    width: calc(0.3125rem * var(--mantine-scale));\n    height: calc(1.5625rem * var(--mantine-scale));\n  }\n\n.m_eae68602:where([data-orientation='horizontal']) {\n    width: calc(1.5625rem * var(--mantine-scale));\n    height: calc(0.3125rem * var(--mantine-scale));\n  }\n\n.m_d98df724 {\n  position: relative;\n  flex: 0 0 var(--carousel-slide-size, 100%);\n}\n\n.m_17884d0f:where([data-include-gap-in-size]) .m_d98df724:where([data-orientation='vertical']) {\n      padding-bottom: var(--carousel-slide-gap);\n    }\n\n.m_17884d0f:where([data-include-gap-in-size]) .m_d98df724:where([data-orientation='horizontal']) {\n      padding-inline-end: var(--carousel-slide-gap);\n    }\n\n.m_17884d0f:where(:not([data-include-gap-in-size])) .m_d98df724:where([data-orientation='vertical']) {\n      margin-bottom: var(--carousel-slide-gap);\n    }\n\n.m_17884d0f:where(:not([data-include-gap-in-size])) .m_d98df724:where([data-orientation='horizontal']) {\n      margin-inline-end: var(--carousel-slide-gap);\n    }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
